import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=32ecc2c1&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=js&"
export * from "./OrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=32ecc2c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ecc2c1",
  null
  
)

export default component.exports